// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import styled, { withTheme } from 'styled-components';
import { PlayerDemo } from '../../../styles';
import type { StatsRadioPlayerRecentlyPlayedSongsData, RecentlyPlayedSongsTheme } from '../../../../domain/PlayerConfiguration';

const Subtitle = styled.div`
  font-size: 17px;
  font-style: italic;
  margin-bottom: 10px;
`;

const SongDescription = styled.div`
  flex-shrink: 1;
`;

const SongTitle = styled.div`
  word-wrap: break-word;
  font-size: 17px;
  color: black;
`;

const SongArtist = styled.div`
  word-wrap: break-word;
  font-size: 13px;
  font-style: italic;
  color: gray;
`;

const SongDate = styled.div`
  margin-left: 5px;
  white-space: nowrap;
  font-weight: bold;
  font-size: 15px;
`;

const SongContainer = styled.div`
  padding: 10px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

type Props = {
  colors: RecentlyPlayedSongsTheme,
  data: StatsRadioPlayerRecentlyPlayedSongsData,
  name: string,
  theme: any,
  t: any,
}

function RecentlyPlayedSongs(props: Props) {
  return (
    <PlayerDemo style={{ backgroundColor: props.colors.backgroundColor, height: 'auto', padding: `${props.theme.metrics.margin}px 24px` }}>
      <div style={{ color: props.colors.mainTextColor, fontSize: '30px' }}>
        {props.t('recentlyPlayed')}
      </div>
      <Subtitle style={{ color: props.colors.secondaryText }}>
        {props.t('lastSongsPlayedOn') + props.name}
      </Subtitle>
      { renderSongExample(props) }
      { renderSongExample(props) }
      { renderSongExample(props) }
    </PlayerDemo>
  );
}

export function renderSongExample(props: Props) {
  return (
    <SongContainer>
      <SongDescription>
        <SongTitle style={{ color: props.colors.mainTextColor }}>{props.t('songTitleExemple')}</SongTitle>
        <SongArtist style={{ color: props.colors.secondaryText }}>{props.t('songArtistExemple')}</SongArtist>
      </SongDescription>
      <SongDate style={{ color: props.colors.mainTextColor }}>{props.t('songDateExemple')}</SongDate>
    </SongContainer>
  );
}

export default withTheme(translate('radioConfiguration')(RecentlyPlayedSongs));



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/playerConfigurationForm/statsRadioPlayer/demos/RecentlyPlayedSongsDemo.js